module.exports = __webpack_public_path__ + "static/media/icon_crm.47b88acd.png";